import { Box, Button, Container, Img, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import './MenDetails.css';
import { ChevronRightIcon, AddIcon } from "@chakra-ui/icons";



const fetchData = () => {
    return fetch("https://fake-eval-app.herokuapp.com/womens")
}

const WomenDetails = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchData()
         .then(res=>res.json())
         .then(res=>{
             setData(res)
             console.log(res)
           })
    },[])

    return(
        <div className="men_main_body">
                <hr />
                <div className="link_men_left_side">
                <p><ChevronRightIcon />Accessories</p>
                <p><ChevronRightIcon />Activewear</p>
                <p><ChevronRightIcon />Belts</p>
                <p><ChevronRightIcon />Coats & Jackets</p>
                <p><ChevronRightIcon />Footwear</p>
                <p><ChevronRightIcon />Handbags</p>
                <p><ChevronRightIcon />Jeans and Denim</p>
                <p><ChevronRightIcon />Jewelry</p>
                <p><ChevronRightIcon />Jumpsuits and Overalls</p>
                <p><ChevronRightIcon />Luggage</p>
                <p><ChevronRightIcon />Pants</p>
                <p><ChevronRightIcon />Shirts</p>
                <p><ChevronRightIcon />Small Leather Goods</p>
                <p><ChevronRightIcon />Swimwear</p>
                <p><ChevronRightIcon />T-Shirt and Tops</p>
                <p><ChevronRightIcon />Underwear</p>
                <p><ChevronRightIcon />Watches</p>
                <hr />
                <Stack>
                    <Button rightIcon={<AddIcon />} size='lg' > DESIGNERS </Button>
                    <Button rightIcon={<AddIcon />} size='lg' > PRICE RANGE </Button>
                    <Button rightIcon={<AddIcon />} size='lg' > SIZE </Button>
                    <Button rightIcon={<AddIcon />} size='lg' > COLORS </Button>
                    <Button rightIcon={<AddIcon />} size='lg' > PRINT </Button>
                    <Button rightIcon={<AddIcon />} size='lg' > MATERIALS </Button>
                    <Button rightIcon={<AddIcon />} size='lg' > CATEGORY </Button>
                </Stack>  
            </div>
            <div size='md' id="men_right_section">
               <SimpleGrid columns={[1,2,3,4]} spacing={5}>
                {
                    data && data.map((item) => 
                    <Box >
                        <Stack>
                            <Img src={item.image} alt={item.name} h="300px" />
                            <hr />
                            <Text fontWeight={700}>$ {item.price}</Text>
                            <Text>{item.description}</Text>
                            <Button colorScheme='blue' onClick = {()=>alert("Product Added Successfully")} >Add TO Basket</Button>
                        </Stack>
                    </Box>
                    )
                }
               </SimpleGrid>
            </div>
        
        </div>
    )
}

export default WomenDetails;